import { z } from 'zod';

export const picklistOperators = z.enum(['eq', 'in', 'null', 'notnull']);

export type PicklistOperator = z.infer<typeof picklistOperators>;

export const picklistFilter = z
  .object({
    value: z
      .union([z.number(), z.array(z.number())])
      .nullable()
      .optional(),
    operator: picklistOperators,
  })
  .optional();

export const backlogItemsPicklistFilterSchema = z.object({
  backlogTeamId: picklistFilter,
  backlogEstimationId: picklistFilter,
  backlogItemTypeId: picklistFilter,
  backlogItemStatusId: picklistFilter,
});

export const backlogItemsBooleanFilterSchema = z.object({
  needsTeamOrEstimate: z
    .object({
      value: z.boolean().optional(),
    })
    .optional(),
});

export const backlogItemsFilterSearchSchema = z.object({
  ...backlogItemsPicklistFilterSchema.shape,
  ...backlogItemsBooleanFilterSchema.shape,
});

export const isBacklogItemsPicklistFilterKey = (
  key: string,
): key is keyof typeof backlogItemsPicklistFilterSchema.shape => {
  return Object.keys(backlogItemsPicklistFilterSchema.shape).includes(key);
};
